import React from 'react';

const NewsMoreItems = ({ items }) => {
  const rows = (items || []).filter((item) => item?.url && item?.title);
  if (!rows.length) return null;
  return (
    <section className="news-section" aria-labelledby="news-more-title">
      <h2 id="news-more-title" className="news-section-title">더 볼 만한 소식</h2>
      <p className="news-more-note">요약 없이 원래 기사 제목 그대로 모았어요.</p>
      <ul className="news-more-list">
        {rows.map((item) => (
          <li key={item.item_id || item.url}>
            <a href={item.url} target="_blank" rel="noopener noreferrer nofollow" className="news-more-link">
              <span className="news-more-title">{item.title}</span>
              <span className="news-more-source">
                {item.source_name}
                {item.lang && item.lang !== 'ko' ? ' (영문)' : ''}
                <span aria-hidden="true"> ↗</span>
              </span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default NewsMoreItems;
